// extracted by mini-css-extract-plugin
export default {"button":"PublishButton_button__W+OsI","disabled":"PublishButton_disabled__3pR5J"};